.sn-integration-options-type-1 {
  display: flex;
  flex-direction: column;

  &__wrapper {
    display: flex;
    flex-direction: column;
    gap: map-get($spacings, xl);
    background-color: var(--background-color-secondary);
    border-radius: var(--radius-size-lg);
    padding: map-get($spacings, md);

    @include above($breakpoint-desktop) {
      padding: map-get($spacings, xl);
    }

    @include above($breakpoint-desktop-md) {
      flex-direction: row;
      align-items: center;
      padding: map-get($spacings, 3xl) map-get($spacings, 2xl);
      gap: map-get($spacings, 3xl);
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: map-get($spacings, lg);
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: map-get($spacings, md);

    @include above($breakpoint-desktop-md) {
      grid-template-columns: repeat(5, 1fr);
    }
  }

  &__icon-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--border-color-secondary); // TODO: no exact token (was #e5e5e5)
    border-radius: map-get($border-radii, md);
    padding: map-get($spacings, sm);

    @include size(80px);

    @include above($breakpoint-desktop) {
      padding: map-get($spacings, md);

      @include size(98px);
    }

    &:last-child {
      @include above($breakpoint-desktop-md) {
        grid-column: 4 / span 2;
        grid-row: 1 / span 2;

        @include size(224px);
      }
    }
  }

  &__icon {
    width: 100%;
    object-fit: contain;
  }

  .me-heading--4 {
    font-size: map-get($font-sizes, 2xl);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, 3xl);
    }

    @include above($breakpoint-desktop-md) {
      font-size: map-get($font-sizes, 4xl);
    }
  }

  .me-heading--6 {
    font-size: 24px;
    line-height: 32px;
  }

  .me-text {
    font-size: map-get($font-sizes, md);
    line-height: map-get($line-heights, lg);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, xl);
    }
  }
}
